import { isProcessClient } from "~/utils/process"

export default isProcessClient() ? window : {} as Window & typeof globalThis
